
.paginator {
  display: flex;
  color: var(--sbb-color-grey);
  padding-left: 0;
  list-style: none;
  font-size: 0.938rem;
  margin-top: 0.5rem;

  li {
    position: relative;
    line-height: 0;
    text-align: center;
    outline: 0;
    flex-shrink: 0;
    min-width: 1.875rem;
    height: 1.875rem;

    &.disabled {
      button {
        cursor: auto;
        color: var(--sbb-color-storm);

        &:hover {
          color: var(--sbb-color-storm);
        }
      }
    }

    &.current {
      button {
        border-color: var(--sbb-color-grey);
      }
    }

    button {
      background: none;
      background-image: none;
      cursor: pointer;
      border-radius: 1.5em;
      border: 1px solid rgba(0, 0, 0, 0);
      text-decoration: none;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      line-height: 1;
      outline: 0;

      &:hover {
        color: var(--sbb-color-red);
      }
    }
  }
}
